import { useEffect } from 'react';

type SeoOptions = {
  title: string;
  description: string;
  /** og:image 절대 URL 권장 */
  image?: string;
  /** canonical / og:url 절대 URL */
  url?: string;
};

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * 페이지별 SEO 태그를 설정한다(CSR이라 Googlebot 렌더 기준).
 * 언마운트 시 문서 제목을 복원한다.
 *
 * 주의: 카카오·페북 등 JS를 실행하지 않는 소셜 크롤러는 index.html의 정적 OG만
 * 읽으므로, 소셜 공유용 개별 OG는 프리렌더 도입 후에 완성된다.
 */
export function useSeo({ title, description, image, url }: SeoOptions): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (image) {
      upsertMeta('property', 'og:image', image);
      upsertMeta('name', 'twitter:image', image);
    }
    if (url) {
      upsertMeta('property', 'og:url', url);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, image, url]);
}
